import React from "react";
import {BlockContainer, InnerBlockContainer} from "BaseComponents/Wrappers";
import {H3} from "BaseComponents/Text";
import {getButtonColor} from "Helpers/ColorHelper";
import {ImagesListWrapper} from "./ImageListBlock.styles";

export const ImageListBlock = ({
                                   Heading,
                                   Images,
                                   BackgroundColor
                               }) => {

    const {textColor} = getButtonColor(BackgroundColor);
    return (
        <BlockContainer className="imageListBlock" bgColor={`#${BackgroundColor ? BackgroundColor : "fff"}`}>
            <InnerBlockContainer>
                {Heading && <H3
                    margin="0 0 1rem 0"
                    fontWeight="600"
                    color={textColor}
                >
                    {Heading}
                </H3>}
                <ImagesListWrapper>
                    {Images.map((c, i) => {
                        return <img src={c.Source} key={i} alt={c.Alt}/>
                    })}
                </ImagesListWrapper>
            </InnerBlockContainer>
        </BlockContainer>
    );
};
